import type { QueryClient } from '@tanstack/react-query';

export const FAVORITES_QUERY_KEY_ROOT = 'favorites' as const;

export function favoritesQueryKey(organizationId: string | null | undefined) {
  return [FAVORITES_QUERY_KEY_ROOT, organizationId ?? 'none'] as const;
}

/** Clear all favorites cache entries (logout / org switch). */
export function clearFavoritesCache(queryClient: QueryClient) {
  queryClient.removeQueries({ queryKey: [FAVORITES_QUERY_KEY_ROOT] });
}
